module.exports = __webpack_public_path__ + "img/ezgif.com-gif-maker-A.4a9e863d.png";